import { CToastClose } from '@coreui/react';
import React from 'react';

const BaseToastClose = React.memo(({ children, ...rest }) => {
  return <CToastClose {...rest}>{children}</CToastClose>;
});

export default BaseToastClose;
